import React, { Component, CSSProperties } from "react";
import { IHotelBillCodesParameter, Istate } from "../../../Model/IHotelBillCodes";
import {FormLabel,Container,Row,Col,Form,Alert,Button,Card,NavLink,FormControl,Table,InputGroup,FormGroup} from "react-bootstrap";
import {FormModalSpinner} from '../../CustomComponents/FormModalSpinner';
import { FormSelect } from "../../CustomComponents/FormSelect";
import { FormInputs } from "../../CustomComponents/FormInput";
import { BCDcodeMaintenanceController } from "../../../Controllers/BCDcodeMaintenanceController";
import '../../../assets/css/Style.css'
import { format } from 'date-fns'
import ReactPaginate from 'react-paginate';
import { MultilineDropdown } from "react-multiline-dropdown";
import { alert, confirm } from 'react-bootstrap-confirmation';


export class HotelBillCodes extends Component<IHotelBillCodesParameter,Istate> {
    constructor(props:IHotelBillCodesParameter){
        super(props)
        const userLogin = sessionStorage.getItem("userLogin")
        let loggedIn = true;
        if (userLogin == null){
            loggedIn = false;
        }
        this.state={  
            fields: {id:'',name:'',order:'',isEdit:false,isCorporate:false},
            selectfields:{},
            errors:{id:'',name:''},
            errMsg:"",
            loading:false,            
            modal: {modalSpinnerShow: false},           
            userId:sessionStorage.getItem("uid"),
            hotelBillCodesGroups:[]  
        } 
        this.onSave = this.onSave.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);       
        this.onClear = this.onClear.bind(this);
    }

    handleTextChange(e:any){  
        let fields = this.state.fields; 
        let errors = this.state.errors;
        var numregex = new RegExp("^[0-9\b]+$");
        if(e.currentTarget.id === "order")    
        {
            if (e.currentTarget.value === '' ||numregex.test(e.currentTarget.value)) {
                fields[e.currentTarget.id] = e.currentTarget.value;
                errors[e.currentTarget.id] = "";
            }  
        }  
        else
        {       
            fields[e.currentTarget.id] = e.currentTarget.value; 
            errors[e.currentTarget.id] = "";
        }
            
        this.setState({fields,errors});       
    }

    componentWillMount(){
        let modal = this.state.modal;        
        this.setState({userId:sessionStorage.getItem("uid")})
        modal['modalSpinnerShow']=true; 
        this.getHotelBillCodeList();
    }
    
    onClear(e:any)
    {
        e.preventDefault();
        let modal = this.state.modal; 
        modal['modalSpinnerShow']=true; 
        this.clearData();
        this.getHotelBillCodeList();
    }

    clearData()
    {
        let fields = this.state.fields
        let errors = this.state.errors
        fields["id"] ="";
        fields["name"] = "";   
        fields["order"] = "";      
        fields["isEdit"] = false;     
        fields["isCorporate"] = false;   
        errors["id"] ="";
        errors["name"] = ""; 
        this.setState({fields,errors})
    }

    onSave(e:any){
        e.preventDefault();
        let fields = this.state.fields
        let modal = this.state.modal;         
        var doBy = "";
        if(this.validateHotelBillCode())
        {
            modal['modalSpinnerShow']=true; 
            if(fields["isEdit"])
                doBy = "U";
            else
             doBy = "I";
            let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
            var data = {  
                    doBy:doBy,           
                    id:fields["id"],
                    name:fields["name"],
                    order:fields["order"],
                    isCorporate:fields["isCorporate"]
                }
                bcdcodeMaintenanceController.InsUpdDelHotelBillCode(data).then(response => { 
                    if(fields["isEdit"])
                        alert('Hotel Bill Code Updated')
                    else
                        alert('Hotel Bill Code Added') 
                    this.getHotelBillCodeList(); 
                    this.clearData();   
                    modal['modalSpinnerShow']=false;  
                    this.setState({modal})            
                }).catch(error => {
                    console.error("There was an error!", error)
                })   
        }
    }

    async onDelete(data) {      
        var flag = await confirm("Are you sure want to Delete?",{title:"Confirm Delete", okText:"Yes", cancelText:"No"})
        if(flag){
            if(data["id"] == "-1")
            { 
                alert("Cannot DELETE this row due to this is a required key value.")
            }
            else{
                let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
                var data1={
                    id:data["id"]
                }        
                bcdcodeMaintenanceController.GetHotelBillCount(data1).then(response => {            
                var count = response[0].count || "";
                if(count > 0)
                { 
                alert("Cannot DELETE this row due to it is active in the Hotel Booking table.")
                }
                else
                {               
                    var data1 = {  
                        doBy:"D",           
                        id:data["id"],
                        name:data["name"],
                        order:data["order"],
                        isCorporate:data["isCorporate"]
                    }
                    bcdcodeMaintenanceController.InsUpdDelHotelBillCode(data1).then(response => { 
                        alert('Data Deleted..')  
                        this.getHotelBillCodeList();  
                        this.clearData();              
                    }).catch(error => {
                        console.error("There was an error!", error)
                    })   
                }
                }).catch(error => {
                    console.error("There was an error!", error);            
                })
            }
        }
    }

    onEdit=(e:any,data)=>{
        e.preventDefault();
        let fields = this.state.fields
        let errors = this.state.errors
        fields["id"] = data["id"];
        fields["name"] = data["name"]; 
        fields["order"] = data["order"];
        fields["isCorporate"] = data["isCorporate"];
        fields["isEdit"] = true;
        errors["id"] ="";
        errors["name"] = ""; 
        this.setState({fields,errors})        
    }

    validateHotelBillCode=()=>{
        var isValid=true
        let fields = this.state.fields;
        let errors = this.state.errors
        if(fields["id"] === "")
        {
            isValid=false;
            errors["id"] ="Enter ID";
        }
        if(fields["id"] === "-1")
        {
            isValid=false;
            errors["name"] ="Cannot Update this row due to this is a required key value";
        }
        if(fields["name"] === "")
        {
            isValid=false
            errors["name"] ="Enter Name";
        }        
        if(isValid  && !fields["isEdit"])
        {
            var sta = this.state.hotelBillCodesGroups.filter(item => fields["id"] === item.id);
            if(sta.length >0)
            {
                isValid=false
                alert("ID Already Exists.Please Choose Differtent");
            }
        }
        this.setState({errors}) 
        return isValid;
    }    

    getHotelBillCodeList =()=>{
        let modal = this.state.modal;     
        let fields = this.state.fields;     
        let bcdcodeMaintenanceController = new BCDcodeMaintenanceController();
        
        bcdcodeMaintenanceController.GetHotelBillCodesList().then(jsonHotelBillList => {
            this.setState({ hotelBillCodesGroups: JSON.parse(JSON.stringify(jsonHotelBillList))});
            modal['modalSpinnerShow']=false;  
            this.setState({modal}) 
            
        }).catch(error => {
            console.error("There was an error!", error);
            modal['modalSpinnerShow']=false;
            this.setState({modal})
        })
    }

          
    handleCheckChange(i) {
        let fields = this.state.fields;
        fields["isCorporate"] = !fields["isCorporate"]
        this.setState({ fields });
   }

    render() {
        const{ loading } = this.state; 
                     
         const tdStyle = {
            width:'20%',            
            border: "2px solid #eee",
             padding:"2px"           
        };
             
        const thStyle ={
            width:'20%',            
            border: "2px solid #eee",
            padding:"2px"                        
        };        
        return (
        <div className="content">
            <FormModalSpinner show={this.state.modal.modalSpinnerShow} />
            <Container fluid>
                <Row>
                    <Col sm={12}>
                        <Card border="light" style={{ width: '100%' }}>
                            <div className="header"><h4 className="title">Hotel Bill Codes</h4></div>
                            <Card.Body>
                                <Alert variant="danger" style={{ display: this.state.errMsg ? "inherit" : "none"}}>{this.state.errMsg}</Alert>
                                <Row>
                                <Col sm={1}>
                                         <FormInputs
                                                properties={{id:"id",label:"ID",type:"text",name:"id",maxlength:3,value:this.state.fields.id,className:"form-control input-sm",onChange: this.state.fields.isEdit ? "" : this.handleTextChange}}
                                                errorMsg={this.state.errors.id}
                                                fieldRequired={true}
                                                disbled={true}                                                
                                            />
                                       </Col>
                                       <Col sm={4}>
                                            <FormInputs
                                                properties={{id:"name",label:"Name",type:"text",name:"name",maxlength:25,value:this.state.fields.name,className:"form-control input-sm", onChange: this.handleTextChange}}
                                                errorMsg={this.state.errors.name}
                                                fieldRequired={true}
                                                disbled={true}
                                            />
                                        </Col>
                                        <Col sm={1}>
                                            <FormInputs
                                                properties={{id:"order",label:"Order #",type:"text",name:"order",value:this.state.fields.order,className:"form-control input-sm", onChange: this.handleTextChange}}
                                                errorMsg={this.state.errors.order}
                                                fieldRequired={false}
                                                disbled={true}
                                            />
                                        </Col>
                                        <Col sm={2}>
                                            <tr><td>Is Corporate Card</td></tr>
                                            <tr style={{marginTop:"3%"}}><td><input type="checkbox" checked={this.state.fields.isCorporate} onChange={this.handleCheckChange.bind(this)}/></td></tr>
                                        </Col>  
                                        <Col sm={1} style={{marginTop:"2%"}}>
                                            <Button id="save" type="button" size="sm" disabled={loading} variant="success" onClick={(e) => this.onSave(e)}>
                                                {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" , color:"#3472F7" }}
                                                />
                                                )}
                                                {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                {!loading && <span>Add/Update</span>}
                                            </Button>
                                        </Col> 
                                        <Col sm={1} style={{marginTop:"2%",marginLeft:"2%"}}>
                                            <Button id="save" type="button" size="sm" disabled={loading} onClick={(e) => this.onClear(e)}>
                                                {loading && (
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" , color:"#3472F7" }}
                                                />
                                                )}
                                                {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                {!loading && <span>Clear</span>}
                                            </Button>                                            
                                        </Col>                                                                  
                                    </Row>    
                                    <Row>
                                        <Col sm={4}></Col>
                                        
                                    </Row>                                                             
                                    <Row style={{marginBottom:"2%"}}>                                    
                                    </Row>                                    
                                    <Row>                                        
                                       <Col sm={12}>                                        
                                        <div>
                                            <Table hover>
                                                        <thead style={{ backgroundColor: 'yello', fontSize: 'large' }}>
                                                            <tr style={{textAlign:"center"}}>
                                                                <th style={thStyle}>ID</th>
                                                                <th style={thStyle}>Name</th> 
                                                                <th style={thStyle}>Order #</th>   
                                                                <th style={thStyle}>Is Corporate Card</th>                                                                                                                                      
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {this.state.hotelBillCodesGroups.map((prop, key) => {
                                                                return (
                                                                    <tr style={{textAlign:"center",cursor:"pointer"}}  key={key} > 
                                                                    <td style={tdStyle}>{prop["id"]}</td>                                                                                                                         
                                                                    <td style={tdStyle}>{prop["name"]}</td>  
                                                                    <td style={tdStyle}>{prop["order"]}</td> 
                                                                    <td><input type="checkbox" checked={prop["isCorporate"]}/></td>                                                                                        
                                                                    <td style={tdStyle}>
                                                                    <tr>
                                                                            <td style={{borderTop:"0px"}}>
                                                                                <Button id="edit" type="button" size="sm" disabled={loading} onClick={(e) => this.onEdit(e,prop)}>
                                                                                    {loading && (
                                                                                    <i
                                                                                        className="fa fa-refresh fa-spin"
                                                                                        style={{ marginRight: "5px" , color:"#3472F7" }}
                                                                                    />
                                                                                    )}
                                                                                    {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                                                    {!loading && <span>Edit</span>}
                                                                                </Button>
                                                                                <Button id="edit" type="button" size="sm" style={{ marginLeft: "10px"}} disabled={loading} variant="danger" onClick={(e) => this.onDelete(prop)}>
                                                                                    {loading && (
                                                                                    <i
                                                                                        className="fa fa-refresh fa-spin"
                                                                                        style={{ marginRight: "5px" , color:"#3472F7", }}
                                                                                    />
                                                                                    )}
                                                                                    {loading && <span style={{color:"#3472F7"}} >wait...</span>}
                                                                                    {!loading && <span>Delete</span>}
                                                                                </Button>
                                                                            </td>                                                                            
                                                                        </tr>
                                                                    </td>
                                                                    </tr>                                                                    
                                                                )
                                                            })}                                                                                                                      
                                                        </tbody>
                                                </Table>                                                                                                        
                                            </div> 
                                       </Col>
                                    </Row>                                                                   
                           </Card.Body>                                  
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>)
    }
}